import React from 'react';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {getWhatsAppLink} from '../../../_common/utils/format';

export function WhatsAppLinkColumnFormatter(cellContent, intl) {
  const message = [
    'שלום, הודעה לגבי חשבונית מוזמנת עבור',
    cellContent.customerName
  ].filter(Boolean).join(' ');
  const linkToWhatsapp = getWhatsAppLink(cellContent.phone, encodeURI(message))

  const title = intl.formatMessage({
    id: "invoice-orders-column-whatsappLink-title",
    defaultMessage: "WhatsApp link",
  });

  return (
      <a
        href={linkToWhatsapp}
        className={'whatsappColumnButton btn btn-sm mx-auto'}
        title={title}
        target={'_blank'}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Whatsapp_white.svg')}
          alt="whatsapp"
        />
      </a>
  );
}